import axios from "axios";

const CONFIGURED_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Resolve at runtime: use the configured backend host only when we are actually
// being served from it (the preview environment). When the deployed bundle is
// served from a different host (e.g. a custom production domain), fall back to
// the current origin so requests stay same-origin and reach the prod backend
// through the platform ingress (which routes /api/* to FastAPI).
function resolveBackendUrl() {
  if (typeof window === "undefined") return CONFIGURED_BACKEND_URL;
  try {
    const origin = window.location.origin;
    if (!CONFIGURED_BACKEND_URL) return origin;
    return origin === CONFIGURED_BACKEND_URL ? CONFIGURED_BACKEND_URL : origin;
  } catch {
    return CONFIGURED_BACKEND_URL;
  }
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
